export type SnLayoutNavbarMode = 'adaptive' | 'side' | 'modal';
